import plugin from 'tailwindcss/plugin';

export const gridArea = plugin(({ matchUtilities, theme }) => {
  matchUtilities(
    {
      'grid-area': (value) => ({
        'grid-area': value,
      }),
    },
    { values: theme('girdArea') },
  );
});
